import { useState, useRef } from 'react'
import { Button, List } from 'antd'
import InputField from "./InputField"
import { WHITE, BUBBLE_BGND } from "../../styles/styleUtils"
import { useSelector } from "react-redux"
import { getTranslated } from "../../utils/CommonUtils"
import getData from './GetData'
import { CC_PRODUCT_ID } from "../../utils/Constants"
import { useDispatch } from "react-redux"
import { getSessionItem } from "../../utils/storageUtils"
import { SIP_URL } from "../../utils/Config"
import { setContentLoading } from "../../store/reducers/CommonReducer"
import CenteredPopup from './CenteredPopup'

//==============================
// Prefix component Version 1.1
//==============================

const PrefixComponent = ({ numberPattern, digitsPattern, prefixes, setPrefixes }) => {
    // Moved to parent component: const [prefixes, setPrefixes] = useImmer([]);
    const [range, setRange] = useState(""); // Range calculation display
    const [errorAdd, setErrorAdd] = useState(true);
    const [errorsOnrange, setErrorsOnrange] = useState(false);

    const start = useRef();
    const number = useRef();
    const network = useRef();
    const creationAllowed = useRef();

    const [resetPrefixGroup1, setResetPrefixGroup1] = useState(0); // Dummy counter for routing to force redraw
    const [resetPrefixGroup2, setResetPrefixGroup2] = useState(0); // Dummy counter for network to force redraw

    // Selection
    const [selectedItem, setSelectedItem] = useState(null);

    // Informative popup
    const parentRef = useRef(null);
    const [visible, setVisible] = useState(false);
    const [message, setMessage] = useState("");

    const dispatch = useDispatch();
    const dict = useSelector((state) => state.common.dict);
    const oxeAndClientInfo = useSelector((state) => state.oxe.oxeAndClientInfo);
    var ccproductid = getSessionItem(CC_PRODUCT_ID);
    var nodeNumber = oxeAndClientInfo?.nodeNumber || "";

    // List management
    const addRangeInList = (value) => {
        setPrefixes(draft => {
            draft.push(value);
        });
    }

    const removeFromList = () => {
        if (selectedItem) {
            //setData(data.filter(i => i !== selectedItem));
            setPrefixes(prefixes.filter(i => (i.Local_Number !== selectedItem.Local_Number) || ((i.Number_Of_Digit !== undefined) && (i.Number_Of_Digit !== selectedItem.Number_Of_Digit))));
            setSelectedItem(null);
        }
    };

    // Calculate the range from begin with number of digits
    const calculateRange = (begin, number) => {
        let obj = null, beginLength = 0;

        if (begin && number) {
            beginLength = begin.length;

            if (number > beginLength) {
                let first = begin + '0'.repeat(number - beginLength);
                let last = begin + '9'.repeat(number - beginLength);
                obj = "Range: " + first + " - " + last;
            }
        }

        return obj;
    }

    // Check if duplicate in the buffer
    const checkDuplicate = (local_number, nb_digits) => {
        return prefixes.some(item =>
            item.Local_Number === local_number &&
            (item.Number_Of_Digit === nb_digits || (item.Number_Of_Digit === undefined && nb_digits === undefined)));
    }

    // Edit fields handlers
    const updatePrefixStart = (value) => {
        start.current = value;
        if (number.current && number.current.length > 0) {
            setRange(calculateRange(start.current, number.current));
        }
        else {
            setRange("");
        }
        network.current = undefined;
        setResetPrefixGroup2(resetPrefixGroup2 + 1); // Reset the network field
        if ((value !== "") && (value !== undefined) && (number.current !== "") && (number.current !== undefined)) {
            if ((value.length < number.current)) {
                setErrorAdd(false); // no error
                setErrorsOnrange(false);
            }
            else {
                setErrorAdd(true); // The number of digits must be greater than actual start value
                setErrorsOnrange(true);
            }
        }
        else {
            setErrorAdd(true); // Value not yet defined
            setErrorsOnrange(false);
        }
        setSelectedItem(null);
    }

    const updatePrefixLength = (value) => {
        number.current = value;
        if (start.current && start.current.length > 0) {
            setRange(calculateRange(start.current, number.current));
        }
        else {
            setRange("");
        }
        network.current = undefined;
        setResetPrefixGroup2(resetPrefixGroup2 + 1); // Reset the network field
        if ((value !== "") && (value !== undefined) && (start.current !== "") && (start.current !== undefined)) {
            if ((start.current.length < value)) {
                setErrorAdd(false); // no error
                setErrorsOnrange(false);
            }
            else {
                setErrorAdd(true); // The number of digits must be greater than actual start value
                setErrorsOnrange(true);
            }
        }
        else {
            setErrorAdd(true); // Value not yet defined
            setErrorsOnrange(false);
        }
        setSelectedItem(null);
    }

    const updatePrefix = (value) => {
        network.current = value;
        start.current = number.current = undefined;
        setRange("");
        setErrorsOnrange(false);
        setResetPrefixGroup1(resetPrefixGroup1 + 1); // Reset routing fields
        if ((value !== "") && (value !== undefined)) {
            setErrorAdd(false); // no error
        }
        else {
            setErrorAdd(true); // Value not yet defined
        }
        setSelectedItem(null);
    }

    // Handler to display the values in the list
    const displayItem = (value) => {
        let str;

        if (value.Number_Of_Digit !== undefined) {
            str = calculateRange(value.Local_Number, value.Number_Of_Digit);
        } else {
            str = value.Local_Number;
        }
        return str;
    }

    // Handler to select an item in the list
    const handleSelect = (item) => {
        setSelectedItem(item);
    };

    // Add the range in the list
    const addRange = async () => {
        let obj = { "Local_Number": start.current, "Number_Of_Digit": number.current };

        creationAllowed.current = null;

        if (!checkDuplicate(start.current, number.current)) {

            // Verify if the range is configurable in OXE
            await checkRoutingConfiguration();

            if (creationAllowed.current === true) {
                addRangeInList(obj);
            }
            else {
                showPopup("VALUE_NOT_CONFIGURABLE");
            }

            // Reset the value for next check
            creationAllowed.current = null;
        }
        else { 
            // Duplicate error
            showPopup("DUPLICATE_VALUE");
        }
        setRange("");
    }

    // Add network in the list
    const addNetwork = async () => {
        let obj = { "Local_Number": network.current };

        creationAllowed.current = null;

        if (!checkDuplicate(network.current)) {
            // Verify if the prefix is configurable in OXE
            await checkNetworkConfiguration();

            if (creationAllowed.current === true) {
                addRangeInList(obj);
            }
            else {
                showPopup("VALUE_NOT_CONFIGURABLE");
            }

            // Reset the value for next check
            creationAllowed.current = null;
        }
        else { 
            // Duplicate error
            showPopup("DUPLICATE_VALUE");
        }
    }

    // Add prefix in the list
    const addPrefix = () => {
        if (network.current !== undefined) {
            addNetwork();
        }
        else
            if ((start.current !== undefined) && (number.current !== undefined)) {
                addRange();
            }
        start.current = number.current = network.current = undefined;
        setResetPrefixGroup1(resetPrefixGroup1 + 1); // Reset routing fields
        setResetPrefixGroup2(resetPrefixGroup2 + 1); // Reset the network field
        setErrorAdd(true);
        setSelectedItem(null);
    }

    // Test against backend if the configuration can be created

    const routingHandler = (data) => {
        if (data[0]?.creationPossible) {
            creationAllowed.current = data[0]?.creationPossible;
        }
    }

    const checkRoutingConfiguration = async () => {
        var url, response;

        try {
            url = SIP_URL + "/check-callingnumber-creation/" + nodeNumber + "/" + ccproductid + "/" + start.current + "/" + number.current;

            dispatch(setContentLoading(true));
            response = await getData(url, null, routingHandler);
            dispatch(setContentLoading(false));
        }
        catch (e) {
            console.error(e);
            dispatch(setContentLoading(false));
        }
    }
    
    const networkHandler = (data) => {
        if (data[0]?.creationPossible) {
            creationAllowed.current = data[0]?.creationPossible;
        }
    }

    const checkNetworkConfiguration = async () => {
        var url, response;

        try {
            url = SIP_URL + "/check-callingnumber-creation/" + nodeNumber + "/" + ccproductid + "/" + network.current;

            dispatch(setContentLoading(true));
            response = await getData(url, null, networkHandler);
            dispatch(setContentLoading(false));
        }
        catch (e) {
            console.error(e);
            dispatch(setContentLoading(false));
        }
    }

    // Informative popup 
    const showPopup = (msg) => {
        setMessage(getTranslated(dict, msg));
        setVisible(true);
        setTimeout(() => setVisible(false), 3000); // Hide after 3 seconds
    };

    return (<div className="prefix-style">
        <div className={errorsOnrange ? "routing prefix-zone-error" : "routing prefix-zone"}>
            <div className="prefix-title" >{getTranslated(dict, "PARAM_ROUTING_NUMBER")}</div>
            <div className="prefix-fields">
                <InputField label={getTranslated(dict, "PARAM_PREFIX_BEGINNING")}
                    regexp={numberPattern ?? "[0-9A-G*#T]{1,8}"}
                    handleChange={updatePrefixStart}
                    reset={resetPrefixGroup1} />
                <InputField label={getTranslated(dict, "PARAM_PREFIX_NUMBER_DIGITS")}
                    regexp={digitsPattern ?? "[2-8]{1}"}
                    handleChange={updatePrefixLength}
                    reset={resetPrefixGroup1} />
            </div>
            <div className="prefix-range" >{range}</div>
        </div>
        <div className="network">
            <div className="prefix-title" >{getTranslated(dict, "PARAM_NETWORK_NUMBER")}</div>
            <div className="prefix-fields">
                <InputField label={getTranslated(dict, "PARAM_PREFIX_NUMBER")}
                    regexp={numberPattern ??"[0-9A-G*#T]{1,8}"}
                    handleChange={updatePrefix}
                    reset={resetPrefixGroup2} />
                <div className="field-wrap"></div>
            </div>
        </div>
        <div className="action" ref={parentRef}>
            <Button className="add-style" disabled={errorAdd} onClick={addPrefix}>{getTranslated(dict, "LABEL_ADD")}</Button>
            <Button className="remove-style" disabled={!selectedItem} onClick={removeFromList}>{getTranslated(dict, "LABEL_REMOVE")}</Button>
        </div>
        <div className="list" >
            <List className="list-format"
                size="small"
                bordered
                dataSource={prefixes}
                renderItem={(item) => <List.Item key={item} 
                    style={{
                        backgroundColor: item === selectedItem ? BUBBLE_BGND : WHITE,
                        cursor: 'pointer'
                    }}
                    onClick={() => handleSelect(item)}>
                    {displayItem(item)}
                    </List.Item>}>
            </List>
        </div>
        <CenteredPopup parentRef={parentRef} visible={visible} message={message} />
    </div>);
}

export default PrefixComponent;
